/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationRequest,
  TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationResponse,
  TelegramAuthTelegramControllerAuthorizeByTelegramData401,
  TelegramAuthTelegramControllerAuthorizeByTelegramData403,
} from '../../types/TelegramAuthTelegramControllerAuthorizeByTelegramData.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthTelegramAuthorizeByTelegramData } from '../../methods/telegramAuthTelegramAuthorizeByTelegramData.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthTelegramAuthorizeByTelegramDataMutationKey = () =>
  [{ url: '/api/telegram/auth/telegram/login' }] as const;

export type TelegramAuthTelegramAuthorizeByTelegramDataMutationKey = ReturnType<
  typeof telegramAuthTelegramAuthorizeByTelegramDataMutationKey
>;

/**
 * {@link /api/telegram/auth/telegram/login}
 */
export function useTelegramAuthTelegramAuthorizeByTelegramData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationResponse,
      ResponseErrorConfig<
        | TelegramAuthTelegramControllerAuthorizeByTelegramData401
        | TelegramAuthTelegramControllerAuthorizeByTelegramData403
      >,
      { data: TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthTelegramAuthorizeByTelegramDataMutationKey();

  return useMutation<
    TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthTelegramControllerAuthorizeByTelegramData401
      | TelegramAuthTelegramControllerAuthorizeByTelegramData403
    >,
    { data: TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthTelegramAuthorizeByTelegramData(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
